import "@mdi/font/scss/materialdesignicons.scss";
import "tiny-slider/src/tiny-slider.scss";

import moment from "moment";
import PhotoSwipe from "photoswipe/dist/photoswipe.js";
import PhotoSwipeUI_Default from "photoswipe/dist/photoswipe-ui-default.js";
import "photoswipe/dist/photoswipe.css";
import "photoswipe/dist/default-skin/default-skin.css";

self.moment = moment;

function initializePhotoSwipe()
{
	let galleries = document.querySelectorAll('.wp-block-gallery');
	let images = document.querySelectorAll('.wp-block-image');

	if(galleries)
	{
		galleries.forEach(gallery =>
		{
			gallery.setAttribute('data-photoswipe', '');

			let imageLinks = gallery.querySelectorAll('a');

			if(imageLinks)
			{
				let index = 0;

				imageLinks.forEach(link =>
				{
					let img = link.querySelector('img');
					let width = '';
					let height = '';
					let url = '';

					const imageLoad = () =>
					{
						if(link.dataset.width !== "" && link.dataset.height !== "" && !(link.dataset.width <= 1) && !(link.dataset.height <= 1))
						{
							width = img.naturalWidth;
							height = img.naturalHeight;
							url = img.currentSrc;
							gallery.classList.add('enabled');
						} else {
							setTimeout(imageLoad, 1000);
						}
					}
					imageLoad();

					link.classList.add('photo-link');
					link.setAttribute('data-width', width);
					link.setAttribute('data-height', height);
					link.setAttribute('data-large-url', url);

					if(gallery.classList.contains('one-image-gallery'))
					{
						if(index !== 0)
						{
							link.closest('li.blocks-gallery-item').style.display = 'none';
						}
					}

					index++;
				});
			}
		});
	}

	if(images)
	{
		images.forEach(image =>
		{
			image.setAttribute('data-photoswipe', '');

			let link = image.querySelector('a');

			if(link && link.href.indexOf("wp-content") > -1)
			{
				let img = link.querySelector('img');
				let width, height, url;

				const imageLoad = () =>
				{
					if(link.dataset.width !== "" && link.dataset.height !== "" && !(link.dataset.width <= 1) && !(link.dataset.height <= 1))
					{
						width = img.naturalWidth;
						height = img.naturalHeight;
						url = img.currentSrc;
						image.classList.add('enabled');
					} else {
						setTimeout(imageLoad, 1000);
					}
				}
				imageLoad();

				link.classList.add('photo-link');
				link.setAttribute('data-width', width);
				link.setAttribute('data-height', height);
				link.setAttribute('data-large-url', url);
			} else
			{
				image.classList.add('enabled');
			}
		});
	}

	Array
		.from(document.querySelectorAll("[data-photoswipe]"))
		.forEach(gallery => initializeGallery(gallery));
}

function initializeGallery(container)
{
	const items = [];
	const pswp = document.querySelector(".pswp");
	const photoLinks = container.querySelectorAll(".photo-link");

	const openGallery = (evt, launchFrom) =>
	{
		const gallery = new PhotoSwipe(pswp, PhotoSwipeUI_Default, items, {

			index: launchFrom,
			showHideOpacity: true,

			getThumbBoundsFn(index)
			{
				const photo = photoLinks[index];
				const {top, left, height, width} = photo.getBoundingClientRect();

				return {
					x: left,
					y: top + (document.scrollingElement || document.documentElement).scrollTop,
					w: width,
					h: height
				};
			}

		});
		gallery.init();

		evt.preventDefault();
		evt.stopPropagation();
	};

	photoLinks.forEach((photo, index) =>
	{
		const height = parseInt(photo.dataset.height);
		const width = parseInt(photo.dataset.width);
		const src = photo.dataset.largeUrl;

		items.push({
			src: src,
			w: width,
			h: height
		});

		photo.addEventListener("click", evt => openGallery(evt, index));
	});
}

window.onload = function()
{
	if(document.readyState === "complete" || document.readyState === "interactive")
	{
		setTimeout(() =>
		{
			initializePhotoSwipe();
		}, 1500);
	}
};